import { memo } from "react";

function IconLogo_GEVA() {
  return (
    <svg
      width="99"
      height="26"
      viewBox="0 0 99 26"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_199_435)">
        <path
          d="M85.3585 23.6671L82.9089 19.4813C82.5835 18.9253 82.9845 18.2261 83.6286 18.2261H88.528C89.1722 18.2261 89.5731 18.9253 89.2478 19.4813L86.798 23.6671C86.476 24.2174 85.6806 24.2174 85.3585 23.6671Z"
          fill="#00C7B1"
        />
        <path
          d="M69.8723 9.15527e-05C69.6255 9.15527e-05 69.4062 0.157492 69.3274 0.391392L62.8963 19.4561C62.6922 20.061 62.202 20.1514 61.9279 20.1514C61.6536 20.1514 61.1634 20.0612 60.9593 19.4561L54.5263 0.391292C54.4474 0.157492 54.2281 9.15527e-05 53.9813 9.15527e-05H49.4977C49.1042 9.15527e-05 48.827 0.386292 48.9528 0.759092L55.8443 21.182C56.9691 24.5159 60.4506 26.3675 64.1456 25.1981C65.94 24.6304 67.3311 23.1984 67.9327 21.4151L74.9005 0.759092C75.0262 0.386192 74.749 9.15527e-05 74.3555 9.15527e-05H69.8723Z"
          fill="#041C2C"
        />
        <path
          d="M78.1829 25.4509C78.4297 25.4509 78.649 25.2934 78.7278 25.0596L85.0923 6.19243C85.2964 5.58723 85.7867 5.49693 86.0608 5.49693C86.3349 5.49693 86.8252 5.58723 87.0293 6.19243L93.396 25.0596C93.4749 25.2935 93.6942 25.4509 93.941 25.4509H98.4244C98.8179 25.4509 99.0952 25.0647 98.9693 24.6918L92.1443 4.46623C91.249 1.81283 88.8609 0.0984328 86.0606 0.0986328C83.2601 0.0988328 80.8724 1.81343 79.9772 4.46703L73.1547 24.6919C73.0289 25.0647 73.3062 25.4509 73.6997 25.4509H78.1829Z"
          fill="#041C2C"
        />
        <path
          d="M44.3693 5.1152H27.1329C26.8145 5.1152 26.5564 4.8571 26.5564 4.5387V0.5764C26.5564 0.2581 26.8145 0 27.1329 0H44.3693C44.6881 0 44.9467 0.2585 44.9467 0.5773V4.5379C44.9467 4.8567 44.6881 5.1152 44.3693 5.1152Z"
          fill="#041C2C"
        />
        <path
          d="M44.3693 25.5493H27.1329C26.8145 25.5493 26.5564 25.2912 26.5564 24.9728V21.0105C26.5564 20.6922 26.8145 20.4341 27.1329 20.4341H44.3693C44.6881 20.4341 44.9467 20.6926 44.9467 21.0114V24.972C44.9467 25.2908 44.6881 25.5493 44.3693 25.5493Z"
          fill="#041C2C"
        />
        <path
          d="M44.3693 15.3325H27.1329C26.8145 15.3325 26.5564 15.0744 26.5564 14.756V10.7937C26.5564 10.4754 26.8145 10.2173 27.1329 10.2173H44.3693C44.6881 10.2173 44.9467 10.4758 44.9467 10.7946V14.7552C44.9467 15.074 44.6881 15.3325 44.3693 15.3325Z"
          fill="#041C2C"
        />
        <path
          d="M9.02224 25.5457C7.24092 25.5457 5.66781 25.1532 4.30291 24.3683C2.93801 23.5834 1.87385 22.4773 1.11043 21.0502C0.370143 19.5993 0 17.9343 0 16.0553V9.49044C0 7.61138 0.370143 5.95828 1.11043 4.53115C1.87385 3.08023 2.93801 1.96231 4.30291 1.17738C5.69095 0.392462 7.28719 0 9.09164 0H12.9781C14.7132 0 16.24 0.356783 17.5587 1.07035C18.8773 1.78392 19.8952 2.7948 20.6123 4.10301C21.3526 5.41121 21.7228 6.9216 21.7228 8.63416H17.0034C17.0034 7.34974 16.6333 6.31506 15.893 5.53014C15.1527 4.74522 14.1811 4.35276 12.9781 4.35276H9.09164C7.79614 4.35276 6.75511 4.85225 5.96856 5.85125C5.182 6.82645 4.78873 8.11087 4.78873 9.70451V15.8412C4.78873 17.4348 5.17043 18.7311 5.93386 19.7301C6.72041 20.7053 7.74987 21.1929 9.02224 21.1929H13.1169C14.2968 21.1929 15.2684 20.7529 16.0318 19.8728C16.8184 18.9928 17.2117 17.8986 17.2117 16.5904V15.8055H10.4797V11.5241H21.931V16.5904C21.931 18.3268 21.5608 19.8728 20.8205 21.2286C20.0803 22.5844 19.0392 23.6428 17.6975 24.404C16.3557 25.1651 14.8289 25.5457 13.1169 25.5457H9.02224Z"
          fill="url(#paint0_linear_199_435)"
        />
      </g>
      <defs>
        <linearGradient
          id="paint0_linear_199_435"
          x1="0"
          y1="12.7728"
          x2="21.931"
          y2="12.7728"
          gradientUnits="userSpaceOnUse">
          <stop stopColor="#FF5252" />
          <stop offset="1" stopColor="#041C2C" />
        </linearGradient>
        <clipPath id="clip0_199_435">
          <rect width="99" height="26" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}
export default memo(IconLogo_GEVA);
